<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <p-toast position="top-center" />

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Batches_Title' | translateWF: 'Batches' }}</h1>
      </div>
    </div>

    <div class="cs-page-list-grid">
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <p-panel [header]="'Batches_Title' | translateWF: 'Batches'">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="batches()" dataKey="id" [lazy]="true" (onSort)="onSort($event)" selectionMode="single">
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="number">
                  {{ 'Batch_Number' | translateWF: 'Number' }}
                  <p-sortIcon field="number"></p-sortIcon>
                </th>
                <th>{{ 'Batch_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'Batch_Recipe' | translateWF: 'Product Recipe' }}</th>
                <th class="text-right">{{ 'Batch_Planned_Qty' | translateWF: 'Planned Qty' }}</th>
                <th>{{ 'Batch_UOM' | translateWF: 'UOM' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-batch>
              <tr (click)="redirectToDetails(batch.id)" class="cursor-pointer">
                <td class="font-medium">{{ batch.number }}</td>
                <td>
                  <p-tag [value]="getStatusLabel(batch.status)" [severity]="getStatusSeverity(batch.status)" />
                </td>
                <td>
                  <span class="font-medium">{{ batch.productDevelopmentNumber }}</span>
                  @if (batch.productRecipe?.name) {
                    <span class="text-gray-500 ml-2">{{ batch.productRecipe.name }}</span>
                  }
                </td>
                <td class="text-right">{{ batch.plannedQuantity }}</td>
                <td>{{ getUomLabel(batch.uom) }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="5" class="text-center py-8 text-gray-400">
                  {{ 'Batch_No_Records' | translateWF: 'No batches found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize()"
            [totalRecords]="totalRecords()"
            [first]="(currentPage() - 1) * pageSize()"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[25, 50, 100]"
            class="mt-4"
          />
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
